import { useCallback } from 'react';

export default schema =>
  useCallback(
    values => {
      try {
        schema.validateSync(values, { abortEarly: false });
        return {};
      } catch (e) {
        const errs = e.inner?.length ? e.inner : [e];
        return errs.reduce((acc, err) => {
          if (err.path) acc[err.path] = [err.message];
          return acc;
        }, {});
      }
    },
    [schema]
  );
